module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/180119-001-AI-972c427409f4c4e6f8150eb9cb996b0e.jpg";